"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInner = void 0;
const React = require("react");
const Dialog_1 = require("../../../../structure/Dialog");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "FormInner");
/**
 * Top-level form component.
 */
const FormInner = ({ onSubmit, title = false, submitLabel = "Submit", onCancel, cancelLabel, children }) => {
    const actions = [];
    if (typeof onSubmit === "function") {
        actions.push({ label: submitLabel, onClick: onSubmit });
    }
    return (React.createElement("form", { className: css(""), onSubmit: e => {
            e.preventDefault();
            if (typeof onSubmit === "function") {
                onSubmit();
            }
        } },
        title && (React.createElement("div", { "data-test": "header" },
            React.createElement(Dialog_1.DialogHeader, null, title))),
        React.createElement("div", { "data-test": "body" }, children),
        React.createElement("div", { "data-test": "footer" },
            React.createElement(Dialog_1.DialogFooter, { actions: actions, onCancel: typeof onCancel === "function" ? onCancel : undefined, cancelLabel: cancelLabel }))));
};
exports.FormInner = FormInner;
// HACK - legacy support
exports.default = exports.FormInner;
//# sourceMappingURL=index.js.map